import useScreenSize from 'hooks/size';
import React from 'react';
import styles from './grid.module.css';

export const GridColumn = ({ span = 1, auto_columns = true, children }) => {
  const { isMobile } = useScreenSize();

  const wrapper_style = {
    gridColumnEnd: `span ${isMobile ? 1 : span}`,
    gridAutoColumns: auto_columns && 'max-content',
    width: '100%'
  };

  return <div style={wrapper_style}>{children}</div>;
};

export const GridRow = ({
  num_of_columns = 4,
  auto_flow = true,
  children,
  mobileStyles = {},
  tabletStyles = {},
  style = {},
  preserveDefaultStyle = false
}) => {
  const { isMobile, isTablet } = useScreenSize();

  const wrapper_style = {
    gridTemplateColumns:
      isMobile && !preserveDefaultStyle ? '1fr' : `repeat(${num_of_columns}, 1fr)`,
    gridAutoRows: auto_flow && 'max-content',
    ...style,
    ...(isMobile ? mobileStyles : {}),
    ...(isTablet ? tabletStyles : {})
  };

  return (
    <div className={styles.gridRow} style={wrapper_style}>
      {children}
    </div>
  );
};
